module.exports = __webpack_public_path__ + "static/media/filter_4.3ba3e3d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/filter_4.jpg
// module id = 1864
// module chunks = 0